/**
 * Order Vue Component
 * ------------------------------------------------------------------------------
 * Handles order display and reorder functionality
 */

import { app } from '../app.js';

export default {
    data() {
        return {
            isReordering: false
        }
    },

    methods: {
        // Generate unique ID using the same format as product.js generatedUniqueId()
        generateUniqueId() {
            return `${Math.floor(Math.random() * Math.floor(Math.random() * Date.now()))}`;
        },

        async handleReorder(event) {
            event.preventDefault();
            
            const button = event.target;
            const urls = button.getAttribute('data-href').split(',');
            
            this.isReordering = true;
            button.classList.add('button--disabled');
            
            try {
                // Parse all URLs into cart items for batch request
                const items = urls.map(url => {
                    // Generate a new unique ID for each reordered item
                    const newUniqueId = this.generateUniqueId();
                    
                    // Parse URL parameters
                    const params = new URLSearchParams(url);
                    const item = {
                        id: params.get('id'),
                        quantity: parseInt(params.get('quantity')) || 1,
                        properties: {}
                    };
                    
                    // Extract all properties from the URL
                    for (const [key, value] of params.entries()) {
                        if (key.startsWith('properties[') && key.endsWith(']')) {
                            const propertyKey = key.slice(11, -1); // Remove 'properties[' and ']'
                            item.properties[propertyKey] = value;
                        }
                    }
                    
                    // Replace or add the unique ID
                    item.properties['_uniqueID'] = newUniqueId;
                    
                    return item;
                });
                
                // Make single batch request to add all items
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ items })
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                await app.getCart(true);
                app.isMinicartOpen = true;
                
            } catch (error) {
                console.error('Error adding items to cart:', error);
            } finally {
                this.isReordering = false;
                button.classList.remove('button--disabled');
            }
        }
    }
};